import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";

import { getWellStatus, getWellCategory } from "service/wellSummary";
import SectionSetting from "components/common/SectionSetting";
function WellStatusChart(props) {
  const { assetId } = props;
  const [statusSeries, setStatusSeries] = useState(null);
  const [categorySeries, setCategorySeries] = useState(null);

  useEffect(() => {
    if (assetId == null) return;

    getWellStatus(
      assetId,
      (result) => {
        updateStatusSeries(result);
      },
      (error) => {}
    );
    getWellCategory(
      assetId,
      (result) => {
        updateCategorySeries(result);
      },
      (error) => {}
    );
  }, [assetId]);

  function updateStatusSeries(data) {
    let dataSeries = [];
    const keys = Object.keys(data);
    for (const category of keys) {
      dataSeries.push({ name: category, value: data[category] });
    }
    setStatusSeries(dataSeries);
  }

  function updateCategorySeries(data) {
    let dataSeries = [];
    const keys = Object.keys(data);
    for (const category of keys) {
      dataSeries.push({ name: category, value: data[category] });
    }
    setCategorySeries(dataSeries);
  }

  // AV-C1: the previous chart used roseType:"area" (Nightingale rose). In a rose
  // chart every slice shares the same angle and the *radius* encodes the count,
  // so the perceived area grows with the square of the value — small counts look
  // far smaller than they are and large counts are exaggerated. For a simple
  // count breakdown that is a proportion lie. Switch to a plain pie where the
  // swept ANGLE (hence area) is exactly proportional to the count, and surface
  // the share as a percentage so the read-out matches the actual tally
  // (PE 验收: 占比读数与实际计数一致).
  function getOptions(data, title, series_name) {
    return {
      title: {
        text: title,
        textStyle: {
          color: "#fff",
          fontSize: 12,
        },
      },
      tooltip: {
        trigger: "item",
        // count + true share of total; {d} is echarts' percentage of the sum.
        formatter: "{b}: {c} ({d}%)",
      },
      legend: {
        top: "bottom",
        textStyle: {
          color: "#fff",
        },
      },
      series: [
        {
          name: series_name,
          type: "pie",
          radius: ["30%", "70%"],
          // AV-C1: NO roseType — angle-proportional pie, area == proportion.
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: "inside",
            // show count and its true percentage of the total
            formatter: "{c}\n({d}%)",
            color: "#fff",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "20",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: false,
          },
          data: data,
        },
      ],
    };
  }

  return (
    <div className="cards-container h-100">
      <div className="cards-header d-flex flex-row justify-content-between align-items-center">
        <span className="header-title">Well Status</span>
        <div className="header-menu-container d-flex flex-row">
          <div className="cards-setting-btn">
            <SectionSetting disable />
          </div>
        </div>
      </div>
      <div className="cards-content">
        <div className="h-100 row g-0">
          <ReactECharts
            option={getOptions(statusSeries, "Well Status", "Well Status")}
            className="col w-50"
          />
          <ReactECharts
            option={getOptions(
              categorySeries,
              "Well Category",
              "Well Category"
            )}
            className="col w-50"
          />
        </div>
      </div>
    </div>
  );
}

export { WellStatusChart };
